/**
 * ONBOARDING JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Onboarding
         * Set sliders functions etc
         */
        console.log( 'Onboarding - init' );
		
		this.onboarding_question_1 = '';
		this.onboarding_question_2 = '';
		this.onboarding_question_3 = '';
		this.onboarding_question_4 = '';
		this.onboarding_identify_as_having_a_disability = '';
        this.onboarding_your_location = '';
        this.onboarding_your_gender = '';

		// Remove video embed from Step 5 to prevent video continuing to play when moving to next step...
		$( '.remove_video_embed' ).on( 'click', function( event ) {
			$( '.onboarding-video-embed' ).remove();
			event.preventDefault();
		});
				
		// ONBOARDING QUESTIONS SLIDERS / RADIOGROUPS...

		// Q1 Radio - Change:
		$( 'input[name="onboarding_question_1"]' ).on( 'change', function( event ) {
			//console.log( '' );
			//console.log( 'Question 1 Radio CHANGE: ' + $( 'input[name="onboarding_question_1"]:checked' ).val() );
			$( '.onboarding_question_1_next' ).removeClass( 'disabled' );
			event.preventDefault();
		});

		// Q1 Radio - Click:
		$( 'input[name="onboarding_question_1"]' ).on( 'click', function( event ) {
			//console.log( 'Question 1 Radio CLICK: ' + $( 'input[name="onboarding_question_1"]:checked' ).val() );
			$( '.onboarding_question_1_next' ).removeClass( 'disabled' );
			var ob_q1_radio_value = $( this ).val();
			var ob_q1_set_slider_value = 0;
			if ( ob_q1_radio_value == 'a' ) {
				ob_q1_set_slider_value = 0;
			} else if ( ob_q1_radio_value == 'b' ) {
				ob_q1_set_slider_value = 20;
			} else if ( ob_q1_radio_value == 'c' ) {
				ob_q1_set_slider_value = 40;
			} else if ( ob_q1_radio_value == 'd' ) {
				ob_q1_set_slider_value = 60;
			} else if ( ob_q1_radio_value == 'e' ) {
				ob_q1_set_slider_value = 80;
			} 
			$( '#onboarding_question_1_slider input' ).val( ob_q1_set_slider_value ).trigger( 'change' );
			
			event.preventDefault();
		});

		// Q1 Slider - Change:
		$( '#onboarding_question_1_slider' ).on( 'changed.zf.slider', function( event, handle ) {
			var ob_q1_slider_value = $( this ).children( 'input' ).val();
			//console.log( 'Question 1 Slider changed: ' + ob_q1_slider_value );
			$( '#onboarding_question_1_slider_labels li' ).removeClass( 'active' );
			// Check value and set correct radiobutton option 
			if ( ob_q1_slider_value == 0 ) {
				$( '#onboarding_question_1_a' ).prop( 'checked', true ); 
				$( '#onboarding_question_1_slider_labels .slider-label-a' ).addClass( 'active' ); 
			} else if ( ob_q1_slider_value == 20 ) {
				$( '#onboarding_question_1_b' ).prop( 'checked', true ); 
				$( '#onboarding_question_1_slider_labels .slider-label-b' ).addClass( 'active' ); 
			} else if ( ob_q1_slider_value == 40 ) {
				$( '#onboarding_question_1_c' ).prop( 'checked', true );
				$( '#onboarding_question_1_slider_labels .slider-label-c' ).addClass( 'active' ); 
			} else if ( ob_q1_slider_value == 60 ) {
				$( '#onboarding_question_1_d' ).prop( 'checked', true );
				$( '#onboarding_question_1_slider_labels .slider-label-d' ).addClass( 'active' ); 
			} else if ( ob_q1_slider_value == 80 ) {
				$( '#onboarding_question_1_e' ).prop( 'checked', true ); 
				$( '#onboarding_question_1_slider_labels .slider-label-e' ).addClass( 'active' ); 
			} 
			$( 'input[name="onboarding_question_1"]' ).change();
		});
		
		
		// Q2 Radio - Change:
		$( 'input[name="onboarding_question_2"]' ).on( 'change', function( event ) {
			//console.log( '' );
			//console.log( 'Question 2 Radio CHANGE: ' + $( 'input[name="onboarding_question_2"]:checked' ).val() );
			$( '.onboarding_question_2_next' ).removeClass( 'disabled' );
			event.preventDefault();
		});

		// Q2 Radio - Click:
		$( 'input[name="onboarding_question_2"]' ).on( 'click', function( event ) {
			//console.log( 'Question 2 Radio CLICK: ' + $( 'input[name="onboarding_question_2"]:checked' ).val() );
			$( '.onboarding_question_2_next' ).removeClass( 'disabled' );
			var ob_q2_radio_value = $( this ).val();
			var ob_q2_set_slider_value = 0;
			if ( ob_q2_radio_value == 'a' ) {
				ob_q2_set_slider_value = 0;
			} else if ( ob_q2_radio_value == 'b' ) {
				ob_q2_set_slider_value = 20;
			} else if ( ob_q2_radio_value == 'c' ) {
				ob_q2_set_slider_value = 40;
			} else if ( ob_q2_radio_value == 'd' ) {
				ob_q2_set_slider_value = 60;
			}
			$( '#onboarding_question_2_slider input' ).val( ob_q2_set_slider_value ).trigger( 'change' );
			
			event.preventDefault();
		});

		// Q2 Slider - Change:
		$( '#onboarding_question_2_slider' ).on( 'changed.zf.slider', function( event, handle ) {
			var ob_q2_slider_value = $( this ).children( 'input' ).val();
			//console.log( 'Question 2 Slider changed: ' + ob_q2_slider_value );
			$( '#onboarding_question_2_slider_labels li' ).removeClass( 'active' );
			$( '#onboarding_question_2_slider_descriptions li' ).hide();
			// Check value and set correct radiobutton option 
			if ( ob_q2_slider_value == 0 ) {
				$( '#onboarding_question_2_a' ).prop( 'checked', true ); 
				$( '#onboarding_question_2_slider_labels .slider-label-a' ).addClass( 'active' ); 
				$( '#onboarding_question_2_slider_descriptions .slider-description-a' ).show(); 
			} else if ( ob_q2_slider_value == 20 ) {
				$( '#onboarding_question_2_b' ).prop( 'checked', true );
				$( '#onboarding_question_2_slider_labels .slider-label-b' ).addClass( 'active' );
				$( '#onboarding_question_2_slider_descriptions .slider-description-b' ).show(); 
			} else if ( ob_q2_slider_value == 40 ) {
				$( '#onboarding_question_2_c' ).prop( 'checked', true );
				$( '#onboarding_question_2_slider_labels .slider-label-c' ).addClass( 'active' );
				$( '#onboarding_question_2_slider_descriptions .slider-description-c' ).show(); 
			} else if ( ob_q2_slider_value == 60 ) {
				$( '#onboarding_question_2_d' ).prop( 'checked', true );
				$( '#onboarding_question_2_slider_labels .slider-label-d' ).addClass( 'active' );
				$( '#onboarding_question_2_slider_descriptions .slider-description-d' ).show(); 
			}
			$( 'input[name="onboarding_question_2"]' ).change();
		});
		
		
		// Q3 Radio - Change:
		$( 'input[name="onboarding_question_3"]' ).on( 'change', function( event ) {
			//console.log( '' );
			//console.log( 'Question 3 Radio CHANGE: ' + $( 'input[name="onboarding_question_3"]:checked' ).val() );
			$( '.onboarding_question_3_next' ).removeClass( 'disabled' );
			event.preventDefault();
		});

		// Q3 Radio - Click:
		$( 'input[name="onboarding_question_3"]' ).on( 'click', function( event ) {
			//console.log( 'Question 3 Radio CLICK: ' + $( 'input[name="onboarding_question_3"]:checked' ).val() );
			$( '.onboarding_question_3_next' ).removeClass( 'disabled' );
			var ob_q3_radio_value = $( this ).val();
			var ob_q3_set_slider_value = 0;
			if ( ob_q3_radio_value == 'a' ) {
				ob_q3_set_slider_value = 0;
			} else if ( ob_q3_radio_value == 'b' ) {
				ob_q3_set_slider_value = 20;
			} else if ( ob_q3_radio_value == 'c' ) {
				ob_q3_set_slider_value = 40;
			} else if ( ob_q3_radio_value == 'd' ) {
				ob_q3_set_slider_value = 60;
			}
			$( '#onboarding_question_3_slider input' ).val( ob_q3_set_slider_value ).trigger( 'change' );
			
			event.preventDefault();
		});

		// Q3 Slider - Change:
		$( '#onboarding_question_3_slider' ).on( 'changed.zf.slider', function( event, handle ) {
			var ob_q3_slider_value = $( this ).children( 'input' ).val();
			//console.log( 'Question 3 Slider changed: ' + ob_q3_slider_value );
			$( '#onboarding_question_3_slider_labels li' ).removeClass( 'active' );
			$( '#onboarding_question_3_slider_descriptions li' ).hide();
			// Check value and set correct radiobutton option 
			if ( ob_q3_slider_value == 0 ) {
				$( '#onboarding_question_3_a' ).prop( 'checked', true ); 
				$( '#onboarding_question_3_slider_labels .slider-label-a' ).addClass( 'active' );
				$( '#onboarding_question_3_slider_descriptions .slider-description-a' ).show();
			} else if ( ob_q3_slider_value == 20 ) {
				$( '#onboarding_question_3_b' ).prop( 'checked', true );
				$( '#onboarding_question_3_slider_labels .slider-label-b' ).addClass( 'active' );
				$( '#onboarding_question_3_slider_descriptions .slider-description-b' ).show();
			} else if ( ob_q3_slider_value == 40 ) {
				$( '#onboarding_question_3_c' ).prop( 'checked', true );
				$( '#onboarding_question_3_slider_labels .slider-label-c' ).addClass( 'active' );
				$( '#onboarding_question_3_slider_descriptions .slider-description-c' ).show();
			} else if ( ob_q3_slider_value == 60 ) {
				$( '#onboarding_question_3_d' ).prop( 'checked', true );
				$( '#onboarding_question_3_slider_labels .slider-label-d' ).addClass( 'active' );
				$( '#onboarding_question_3_slider_descriptions .slider-description-d' ).show();
			}
			$( 'input[name="onboarding_question_3"]' ).change();
		});
		
		
		// Q4 Radio - Change:
		$( 'input[name="onboarding_question_4"]' ).on( 'change', function( event ) {
			//console.log( '' );
			//console.log( 'Question 4 Radio CHANGE: ' + $( 'input[name="onboarding_question_4"]:checked' ).val() );
			$( '.onboarding_question_4_next' ).removeClass( 'disabled' );
			event.preventDefault();
		});

		// Q4 Radio - Click:
		$( 'input[name="onboarding_question_4"]' ).on( 'click', function( event ) {
			//console.log( 'Question 4 Radio CLICK: ' + $( 'input[name="onboarding_question_4"]:checked' ).val() );
			$( '.onboarding_question_4_next' ).removeClass( 'disabled' );
			var ob_q4_radio_value = $( this ).val();
			var ob_q4_set_slider_value = 0;
			if ( ob_q4_radio_value == 'a' ) {
				ob_q4_set_slider_value = 0;
			} else if ( ob_q4_radio_value == 'b' ) {
				ob_q4_set_slider_value = 20;
			} else if ( ob_q4_radio_value == 'c' ) {
				ob_q4_set_slider_value = 40;
			} else if ( ob_q4_radio_value == 'd' ) {
				ob_q4_set_slider_value = 60;
			} else if ( ob_q4_radio_value == 'e' ) {
				ob_q4_set_slider_value = 80;
			}
			$( '#onboarding_question_4_slider input' ).val( ob_q4_set_slider_value ).trigger( 'change' );
			
			event.preventDefault();
		});

		// Q4 Slider - Change:
		$( '#onboarding_question_4_slider' ).on( 'changed.zf.slider', function( event, handle ) {
			var ob_q4_slider_value = $( this ).children( 'input' ).val();
			//console.log( 'Question 4 Slider changed: ' + ob_q4_slider_value );
			$( '#onboarding_question_4_slider_labels li' ).removeClass( 'active' );
			// Check value and set correct radiobutton option 
			if ( ob_q4_slider_value == 0 ) {
				$( '#onboarding_question_4_a' ).prop( 'checked', true ); 
				$( '#onboarding_question_4_slider_labels .slider-label-a' ).addClass( 'active' ); 
			} else if ( ob_q4_slider_value == 20 ) {
				$( '#onboarding_question_4_b' ).prop( 'checked', true );
				$( '#onboarding_question_4_slider_labels .slider-label-b' ).addClass( 'active' ); 
			} else if ( ob_q4_slider_value == 40 ) {
				$( '#onboarding_question_4_c' ).prop( 'checked', true );
				$( '#onboarding_question_4_slider_labels .slider-label-c' ).addClass( 'active' ); 
			} else if ( ob_q4_slider_value == 60 ) {
				$( '#onboarding_question_4_d' ).prop( 'checked', true );
				$( '#onboarding_question_4_slider_labels .slider-label-d' ).addClass( 'active' ); 
			} else if ( ob_q4_slider_value == 80 ) {
				$( '#onboarding_question_4_e' ).prop( 'checked', true );
				$( '#onboarding_question_4_slider_labels .slider-label-e' ).addClass( 'active' ); 
			}
			$( 'input[name="onboarding_question_4"]' ).change();
		});
		
		
		/*// Q5 Radio - Change:
		$( 'input[name="onboarding_question_5"]' ).on( 'change', function( event ) {
			//console.log( '' );
			//console.log( 'Question 5 Radio CHANGE: ' + $( 'input[name="onboarding_question_5"]:checked' ).val() );
			$( '.onboarding_question_5_next' ).removeClass( 'disabled' );
			event.preventDefault();
		});

		// Q5 Radio - Click:
		$( 'input[name="onboarding_question_5"]' ).on( 'click', function( event ) {
			//console.log( 'Question 5 Radio CLICK: ' + $( 'input[name="onboarding_question_5"]:checked' ).val() );
			$( '.onboarding_question_5_next' ).removeClass( 'disabled' );
			var ob_q5_radio_value = $( this ).val();
			var ob_q5_set_slider_value = 0;
			if ( ob_q5_radio_value == 'a' ) {
				ob_q5_set_slider_value = 0;
			} else if ( ob_q5_radio_value == 'b' ) {
				ob_q5_set_slider_value = 20;
			} else if ( ob_q5_radio_value == 'c' ) {
				ob_q5_set_slider_value = 40;
			} else if ( ob_q5_radio_value == 'd' ) {
				ob_q5_set_slider_value = 60;
			}
			$( '#onboarding_question_5_slider input' ).val( ob_q5_set_slider_value ).trigger( 'change' );
			
			event.preventDefault();
		});

		// Q5 Slider - Change:
		$( '#onboarding_question_5_slider' ).on( 'changed.zf.slider', function( event, handle ) {
			var ob_q5_slider_value = $( this ).children( 'input' ).val();
			//console.log( 'Question 5 Slider changed: ' + ob_q5_slider_value );
			$( '#onboarding_question_5_slider_labels li' ).removeClass( 'active' );
			// Check value and set correct radiobutton option 
			if ( ob_q5_slider_value == 0 ) {
				$( '#onboarding_question_5_a' ).prop( 'checked', true ); 
				$( '#onboarding_question_5_slider_labels .slider-label-a' ).addClass( 'active' ); 
			} else if ( ob_q5_slider_value == 20 ) {
				$( '#onboarding_question_5_b' ).prop( 'checked', true );
				$( '#onboarding_question_5_slider_labels .slider-label-b' ).addClass( 'active' ); 
			} else if ( ob_q5_slider_value == 40 ) {
				$( '#onboarding_question_5_c' ).prop( 'checked', true );
				$( '#onboarding_question_5_slider_labels .slider-label-c' ).addClass( 'active' ); 
			} else if ( ob_q5_slider_value == 60 ) {
				$( '#onboarding_question_5_d' ).prop( 'checked', true );
				$( '#onboarding_question_5_slider_labels .slider-label-d' ).addClass( 'active' ); 
			}
			$( 'input[name="onboarding_question_5"]' ).change();
		});*/
		
		
		// Q5 Selects:
		$( '#onboarding_identify_as_having_a_disability, #onboarding_your_location, #onboarding_your_gender' ).on( 'change', function( event ) {
			if ( $( '#onboarding_identify_as_having_a_disability' ).val() != '' && $( '#onboarding_your_location' ).val() != '' && $( '#onboarding_your_gender' ).val() != '' ) {
				$( '.onboarding_question_5_next' ).removeClass( 'disabled' );
			} else {
				$( '.onboarding_question_5_next' ).addClass( 'disabled' );
			}
			event.preventDefault();
		});
		
		
		
		// Wait 750ms to ensure the sliders have initiated and triggered their initial `changed` event and then disable `Next` buttons
		setTimeout(function () {
			$( '.onboarding_question_1_next,.onboarding_question_2_next,.onboarding_question_3_next,.onboarding_question_4_next,.onboarding_question_5_next' ).addClass( 'disabled' );
			$( 'input[name="onboarding_question_1"],input[name="onboarding_question_2"],input[name="onboarding_question_3"],input[name="onboarding_question_4"],input[name="onboarding_question_5"]' ).prop( 'checked', false );
			$( '#onboarding_question_1_slider_labels li' ).removeClass( 'active' );
			$( '#onboarding_question_2_slider_labels li' ).removeClass( 'active' );
			$( '#onboarding_question_3_slider_labels li' ).removeClass( 'active' );
			$( '#onboarding_question_4_slider_labels li' ).removeClass( 'active' );
			$( '#onboarding_question_5_slider_labels li' ).removeClass( 'active' );
		}, 750);
		
		
		$(window).on( 'changed.zf.mediaquery', function( event, newSize, oldSize ) {
			// newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint
			if ( newSize != 'small' ) {
				$( '#onboarding_question_1_slider' ).foundation( '_reflow' );
				$( '#onboarding_question_2_slider' ).foundation( '_reflow' );
				$( '#onboarding_question_3_slider' ).foundation( '_reflow' );
				$( '#onboarding_question_4_slider' ).foundation( '_reflow' );
				$( '#onboarding_question_5_slider' ).foundation( '_reflow' );
			}

			//console.log( 'oldSize: ' + oldSize);
			//console.log( 'newSize: ' + newSize);

		});
		
		// Click on 'onboarding_continue_in_dashboard' to submit completed question data to backend storage...
        $( 'body' ).on( 'click', '.onboarding_continue_in_dashboard', ( event ) => {
			console.log( 'ONBOARDING - TRYING TO SAVE DATA...' );
			this.onboarding_question_1 = $( 'input[name="onboarding_question_1"]:checked' ).val();
			this.onboarding_question_2 = $( 'input[name="onboarding_question_2"]:checked' ).val();
			this.onboarding_question_3 = $( 'input[name="onboarding_question_3"]:checked' ).val();
			this.onboarding_question_4 = $( 'input[name="onboarding_question_4"]:checked' ).val();
			this.onboarding_identify_as_having_a_disability = $( '#onboarding_identify_as_having_a_disability' ).val();
			this.onboarding_your_location = $( '#onboarding_your_location' ).val();
			this.onboarding_your_gender = $( '#onboarding_your_gender' ).val();
            this.saveOnboardingData();
			$( '.onboarding_continue_in_dashboard' ).addClass( 'disabled' ).text( 'Saving...' );
			event.preventDefault();
        });
		
		// Mark Onboarding as Completed
		/*$( 'body' ).on( 'click', '.onboarding_completed', ( event ) => {
			// Remove class that prevents user interaction when final onboarding modal is closed
			$( 'section' ).removeClass( 'prevent-interaction' );
			this.markOnboardingCompleted();
		});*/
		
    },
	
	saveOnboardingData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...

		
        //var jsonDataString = JSON.stringify( this.aon_section_1a_data );
        //console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( 'ONBOARDING - SAVE ANSWERS AJAX - START' );
        var meta = { 
					'onboarding_question_1' : this.onboarding_question_1, 
					'onboarding_question_2' : this.onboarding_question_2, 
					'onboarding_question_3' : this.onboarding_question_3, 
					'onboarding_question_4' : this.onboarding_question_4, 
					'onboarding_identify_as_having_a_disability' : this.onboarding_identify_as_having_a_disability, 
					'onboarding_your_location' : this.onboarding_your_location, 
					'onboarding_your_gender' : this.onboarding_your_gender, 
				   };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
			$( location ).attr( 'href', '/' );
			
        }).fail( function ( xhr, status, error ) {
            console.log( 'Error - ' + xhr.status + ': ' + xhr.statusText );
			
        });
        console.log( 'ONBOARDING - SAVE ANSWERS AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.onboarding_question_1 );
        console.table( this.onboarding_question_2 );
        console.table( this.onboarding_question_3 );
        console.table( this.onboarding_question_4 );
        console.table( this.onboarding_identify_as_having_a_disability );
        console.table( this.onboarding_your_location );

    }/*,
	
	markOnboardingCompleted() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
		console.log( 'ONBOARDING - MARK AS COMPLETED AJAX - START' );
		//console.log( 'wpApiSettings.current_user_id: ' + wpApiSettings.current_user_id);
		var meta = { 'onboarding_status' : 'yes' };
		$.ajax({
			url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
			method: 'POST',
			beforeSend: function ( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
			},
			data: {
				'meta' : meta
			}
		}).done( function ( response ) {
			console.log( 'Response: ' );
			console.log( response );
		}).fail( function ( xhr, status, error ) {
            console.log( 'Error - ' + xhr.status + ': ' + xhr.statusText );
			
        });
		console.log( 'ONBOARDING - MARK AS COMPLETED AJAX - END' );

    }*/

}